import React from 'react';
import Api from '../../api/api';
import { SERVER_ERROR } from '../../constants/messages';
import AuthMixin from '../../mixins/authenticationMixin';
import { DismissButton, ModalAlert, ModalHeader, ModalStatusIcon } from '../popups/modal-parts';

import './feedback.scss';

const SUBJECTS = ['General Feedback', 'Suggest a new checklist', 'Fault in a checklist', 'Other'];

class FeedbackForm extends React.Component {
  constructor(){
    super();
    this.state = {
      success: false,
      error: false,
      loading: false,
      subject: '',
      defaultSubject: 'Choose a subject...'
    };
  }

  handleSelect(e){
    var targetValue = '';
    if (Api.selectorMatches(e.currentTarget, 'li')) {
      targetValue = e.currentTarget.textContent;
    } else if (Api.selectorMatches(e.currentTarget, 'select')) {
      targetValue = e.currentTarget.value;
    }

    if(targetValue && targetValue !== this.state.defaultSubject){
      this.setState({ subject: targetValue });
    } else {
      this.setState({ subject: '' });
    }

  }

  handleSubmit(e){
    e.preventDefault();

    const form = e.target;
    const subject = this.state.subject;
    const detail = form.querySelector('textarea').value;

    this.setState({ loading: true });

    if(!subject || !detail) {
      this.setState({
        error: true,
        success: false,
        errorMsg: 'Please fill in all fields',
        loading: false
      });
    } else {
      Api.sendFeedback(this.props.userApiRequest, {subject, detail}, {
        onSuccess: ({data}) => {
          form.reset();
          this.setState({
            success: true,
            error: false,
            loading: false
          });
        },
        onError: () => {
          this.setState({
            error: true,
            success: false,
            loading: false,
            errorMsg: SERVER_ERROR
          });
        }
      });
    }
  }

  render(){
    const { success, error, errorMsg, loading } = this.state;

    if (success) {
      return (
        <div className="modal-body is-centered">
          <ModalStatusIcon type="success" />
          <ModalHeader title="Thanks for your feedback" sub="We read every message and use it to improve Neurochecklists." />
          <div className="modal-actions">
            <DismissButton className="modal-btn modal-btn-secondary">Close</DismissButton>
          </div>
        </div>
      );
    }

    return (
      <div className="modal-body">
        <ModalHeader title="Leave some feedback" sub="Help us make your experience better." />
        <form onSubmit={this.handleSubmit.bind(this)} className="modal-form">
          {error ? <ModalAlert>{errorMsg}</ModalAlert> : null}
          <div className="input-group">
            <label className="input-label" htmlFor="feedback-subject">Subject</label>
            <select
              id="feedback-subject"
              className="input-field"
              defaultValue=""
              onChange={(e) => this.handleSelect(e)}
            >
              <option value="" disabled>{this.state.defaultSubject}</option>
              {SUBJECTS.map((subject) => <option key={subject} value={subject}>{subject}</option>)}
            </select>
          </div>
          <div className="input-group">
            <label className="input-label" htmlFor="feedback-detail">Message</label>
            <textarea id="feedback-detail" className="input-field" name="message" placeholder="Please type your feedback here" />
          </div>
          <button type="submit" className="modal-btn modal-btn-primary" disabled={loading}>
            {loading ? 'Sending…' : 'Send feedback'}
          </button>
        </form>
      </div>
    );
  }
}

export default AuthMixin(FeedbackForm);
